<template>
  <div>
    <base-header class="pb-6">
      <b-row align-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <h6 class="h2 text-white d-inline-block mb-0">Account</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--6">
      <b-row>
        <b-col md="3">
          <user-settings></user-settings>
        </b-col>
        <b-col md="9">
          <subscription v-if="owner"></subscription>
          <payment-methods v-if="owner"></payment-methods>
        </b-col>
      </b-row>
    </b-container>
    <b-modal size="lg" id="reactivate-modal" title="Reactivate Your Account" centered hide-footer hide-header no-close-on-backdrop>
      <div id="close">
        <i class="fas fa-times" @click="close"></i>
      </div>
      <b-row class="mt-3">
        <b-col>
          <img src="/img/brand/claritynow-icon.svg" alt="ClarityNOW Icon" id="modal-img">
        </b-col>
        <b-col>
          <h2>Your Account is Inactive</h2>
          <p>To take advantage of all of the features that ClarityNOW offers you will need to reactivate your account.</p>
          <b-button block variant="danger" class="mt-3" @click="reactivate" :disabled="disabled"><i class="fas fa-circle-notch fa-spin" v-if="disabled"></i> <span v-else>Reactivate Now</span></b-button>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios';
import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import UserSettings from './UserSettings';
import PaymentMethods from './PaymentMethods';
import Subscription from './Subscription';

export default {
  components: {
    RouteBreadCrumb,
    UserSettings,
    PaymentMethods,
    Subscription
  },
  data() {
    return {
      disabled: false,
    }
  },
  computed: {
    userRoute() {
      return this.$store.getters['profile/userRoute'];
    },
    owner() {
      const roles = this.$store.getters["roles/roles"];
      return roles[0] == 'owner';
    },
    active() {
      return this.$store.getters['profile/user'].active;
    }
  },
  methods: {
    async reactivate() {
      this.disabled = true;
      await axios.post(this.userRoute + "/reactivate")
      .then(response => {
        swal.fire({
          title: `Success`,
          text: response.data,
          showConfirmButton: false,
          timer: 1750,
          icon: 'success'
        }).then(result => {
          this.disabled = false;
          this.$bvModal.hide('reactivate-modal');
          this.$store.dispatch("profile/user");
        });
      })
      .catch(error => {
        this.disabled = false;
        this.error(error);
      });
    },
    checkActive() {
      if (!this.active) {
        this.$bvModal.show('reactivate-modal');
      }
    },
    close() {
      this.$bvModal.hide('reactivate-modal');
    },
  },
  mounted() {
    this.checkActive();
  }
};
</script>
<style lang="scss">
#modal-img {
  width: 100%;
}
#close {
  position: absolute;
  right: 13px;
  top: 6px;
  cursor: pointer;
}
</style>